module.exports = __webpack_public_path__ + "img/citilinkCorporate.a004caf9.svg";